import FeatherIcon, { Database, Gift, Home, Map, Zap } from "feather-icons-react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const menuData = [
    {
        id: "dashboard",
        title: "Dashboard",
        iconClass: "fa fa-lg fa-home",
        link: "/superadmin/dashboard",
    },
   
     
     {
        id: "products",
        title: "Products",
        iconClass: "fa fa-lg fa-shopping-cart",
        subMenu: [
            { id: "category", title: "Category", link: "/master/category", formName: "Category" },
            { id: "product-list", title: "Product List", link: "/product/productlist" },
            { id: "delete-product", title: "Delete Product", link: "/product/deleteproduct" },

        ],
    },
   
];
export const Sidebar = ({ isClosed, toggleSidebar }) => {
    const [activeMenu, setActiveMenu] = useState("dashboard");
    const [activeSubMenu, setActiveSubMenu] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        const path = location.pathname;
        let foundMenu = null;
        let foundSub = null;

        for (const menu of menuData) {
            if (menu.link === path) {
                foundMenu = menu.id;
                break;
            } else if (menu.subMenu) {
                for (const sub of menu.subMenu) {
                    if (sub.link === path) {
                        foundMenu = menu.id;
                        foundSub = sub.id;
                        break;
                    }
                }
            }
        }

        setActiveMenu(foundMenu);
        setActiveSubMenu(foundSub);
    }, [location.pathname]);
    const handleMenuClick = (menuId) => {
        setActiveMenu(activeMenu === menuId ? null : menuId);
        setActiveSubMenu(null);
    };

    const handleSubMenuClick = (menuId, subId, glink, formName) => {
        setActiveMenu(menuId);
        setActiveSubMenu(subId);
        navigate(glink, { state: { formName, subId } });
    };

    return (
        <div className={`sidebar-wrapper ${isClosed ? "close_icon" : ""}`} data-layout="stroke-svg">
            {/* Logo Section */}
            <div className="logo-wrapper">
                <a onClick={() => navigate("/superadmin/dashboard")}>
                    <img
                        className="img-fluid"
                        src={require("../assets/images/logo/mainlogo.png")}
                        alt="Logo"
                    />
                </a>
                <div className="back-btn" onClick={toggleSidebar}>
                    <i className="fa fa-angle-left"> </i>
                </div>
                <div className="toggle-sidebar" onClick={toggleSidebar}>
                    <FeatherIcon icon="grid" className="status_toggle middle sidebar-toggle" />
                </div>
            </div>

            <div className="logo-icon-wrapper">
                <a>
                    <img
                        className="img-fluid"
                        src={require("../assets/images/logo/sidebar.jpg")}
                        alt="Logo Icon"
                    />
                </a>
            </div>

            {/* Sidebar Menu */}
            <nav className="sidebar-main">
                <div className="left-arrow" id="left-arrow">
                    <i data-feather="arrow-left"></i>
                </div>
                <div id="sidebar-menu">
                    <ul className="sidebar-links" id="simple-bar">
                        <div className="simplebar-wrapper" style={{ margin: 0 }}>
                            <div className="simplebar-height-auto-observer-wrapper">
                                <div className="simplebar-height-auto-observer"></div>
                            </div>
                            <div className="simplebar-mask">
                                <div className="simplebar-offset" style={{ right: 0, bottom: 0 }}>
                                    <div className="simplebar-content-wrapper" style={{ height: "100%", overflow: "hidden scroll" }}>
                                        <div className="simplebar-content" style={{ padding: 0 }}>
                                            <li className="back-btn">
                                                <a className="active">
                                                    <img className="img-fluid" src="../assets/images/logo/logo-icon.png" alt="" />
                                                </a>
                                                <div className="mobile-back text-end">
                                                    <span>Back </span>
                                                    <i className="fa fa-angle-right ps-2" aria-hidden="true"></i>
                                                </div>
                                            </li>
                                            <li className="sidebar-main-title">
                                                <div>
                                                    <h6 className="lan-1">General</h6>
                                                </div>
                                            </li>

                                            {/* Render Menu Dynamically */}
                                            {menuData.map((menu) => (
                                                <li
                                                    key={menu.id}
                                                    className={`sidebar-list ${activeMenu === menu.id ? "active" : ""}`}
                                                >
                                                    <a
                                                        className={`sidebar-link sidebar-title ${activeMenu === menu.id ? "active" : ""}`}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            if (menu.subMenu) {
                                                                handleMenuClick(menu.id);
                                                            } else if (menu.link) {
                                                                navigate(menu.link);
                                                            }
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {/* {menu.icon} */}
                                                        <i className={menu.iconClass}></i>
                                                        <span>{menu.title}</span>
                                                        {menu.subMenu && (
                                                            <div className="according-menu">
                                                                <i className={`fa ${activeMenu === menu.id ? "fa-angle-down" : "fa-angle-right"}`}></i>
                                                            </div>
                                                        )}
                                                    </a>

                                                    {menu.subMenu && activeMenu === menu.id && (
                                                        <ul className="sidebar-submenu">
                                                            {menu.subMenu.map((sub) => (
                                                                <li key={sub.id}>
                                                                    <a
                                                                        className={activeSubMenu === sub.id ? "active" : ""}
                                                                        onClick={() => handleSubMenuClick(menu.id, sub.id, sub.link, sub.formName)}
                                                                    >
                                                                        {sub.title}
                                                                    </a>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    )}
                                                </li>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="simplebar-placeholder" style={{ width: "auto", height: "2058px" }}></div>
                        </div>
                    </ul>

                    <div className="right-arrow" id="right-arrow">
                        <i data-feather="arrow-right"></i>
                    </div>
                </div>
            </nav>
        </div>
    );
};